export async function sha256Hex(blob: Blob | ArrayBuffer): Promise<string> {
  const buffer = blob instanceof ArrayBuffer ? blob : await blob.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buffer);
  return [...new Uint8Array(digest)]
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
